import { Injectable } from '@angular/core';
import * as moment from 'moment';
import { MainService } from 'src/app/services/main-service.service';

@Injectable({ providedIn: 'root' })
export class DateTimeService {
  constructor(private _main: MainService) {}
  public getFormat(): string {
    return this._main.placeFormat; // add you own logic here
  }
  public getLocale(): string {
    return 'he-IL'; // add you own logic here
  }
}
